import axios from 'axios'

import { getVisitorId, VISITOR_ID_HEADER } from './visitorId'

// Configure axios to automatically send cookies with every request
axios.defaults.withCredentials = true

const axiosIns = axios.create({
// You can add your headers here
// ================================
// baseURL: 'https://some-domain.com/api/',
// timeout: 1000,
// headers: {'X-Custom-Header': 'foobar'}
  withCredentials: true, // Send cookies automatically
})

// H9: send the JWT in the Authorization: Bearer header instead of a `?jwt=`
// query param, so the token never lands in URLs, server/CDN access logs or
// browser history. The token is read from localStorage the same way call sites
// used to read it (JSON.parse of the stored value). We never clobber an
// Authorization header a call already set explicitly.
function attachAuthHeader(config) {
  config.headers = config.headers || {}
  if (config.headers.Authorization || config.headers.authorization)
    return config

  // Only attach the token to same-origin API requests. Never send it to
  // absolute cross-origin URLs (e.g. the third-party map/timezone endpoints) —
  // that would leak the JWT off-origin into a CDN and can trip CORS preflight
  // on the custom header. App API calls all use relative (same-origin) paths.
  const url = config.url || ''
  if (/^https?:\/\//i.test(url)) {
    try {
      if (new URL(url).origin !== window.location.origin)
        return config
    } catch (e) {
      return config
    }
  }

  let token = null
  try {
    token = JSON.parse(localStorage.getItem('jwt') || 'null')
  } catch (e) {
    token = null
  }
  if (token)
    config.headers.Authorization = `Bearer ${token}`

  return config
}

// Attach the stable per-browser visitor id on every request so the server
// can attribute anonymous activity to a single visitor across concurrent
// requests (a server-issued cookie loses this race).
axiosIns.interceptors.request.use(config => {
  const id = getVisitorId()
  if (id) {
    config.headers = config.headers || {}
    config.headers[VISITOR_ID_HEADER] = id
  }

  return attachAuthHeader(config)
})

axios.interceptors.request.use(config => {
  const id = getVisitorId()
  if (id) {
    config.headers = config.headers || {}
    config.headers[VISITOR_ID_HEADER] = id
  }

  return attachAuthHeader(config)
})

export default axiosIns
